export default {
  PROMO: "prd_promo",
  NEW_PRODUCT: "Produit-nouveau",
  ITS_IN_SEASON: "produit_de_saison",
  BEST_SELLER: "prd_meilleure-vente",
  AGAINST_WAIST: "prd_anti-gaspi",
  PROMO_LABEL: "Promo",
  ITS_IN_SEASON_LABEL: "C'est de saison",
  BEST_SELLER_LABEL: "Meilleure vente",
  AGAINST_WAIST_LABEL: "Anti gaspi",
  NEW_PRODUCT_LABEL: "Nouveauté"
}
